<template>
  <div v-if="landingPage">
    
    <form
      v-if="status == false"
      @submit.prevent="submitForm()"
      id="email-form"
      name="email-form"
      class="form-box"
    >
      <img
          v-if="landingPage.heroImage && landingPage.heroImage.imageURL"
          :src="landingPage.heroImage.imageURL"
          width="500"
          alt
          class="hero-image-popup"
      />
      <img
        v-if="landingPage.coverImage && landingPage.coverImage.imageURL"
        :src="landingPage.coverImage.imageURL"
        loading="lazy"
        sizes="(max-width: 767px) 90vw, 600px"
        :alt="landingPage.siteUrl"
        class="cover-image-popup"
      />

      <div class="form-wrap">
        <p class="reg-message">
          {{ landingPage.regMessage }}
        </p>
        <input
          v-for="(field, i) in fields"
          :key="i"
          type="text"
          class="text-field w-input"
          maxlength="256"
          :required="field.required"
          v-model="form[field.slug]"
          :placeholder="field.name + (field.required?' *':'')"
        />
        <!-- <input
          type="text"
          class="text-field w-input"
          maxlength="256"
          v-model="form.lastName"
          required
          name="lastName"
          placeholder="Last Name*"
          id="phone"
        />
        <input
          type="email"
          class="text-field w-input"
          maxlength="256"
          v-model="form.email"
          name="email"
          placeholder="Email*"
          id="email-2"
          required
        /> -->
        <!-- <textarea
          placeholder="Message"
          maxlength="5000"
          id="message"
          name="message"
          name="message"
          class="text-field big w-input"
        /> -->
        <input
          type="submit"
          value="Submit"
          data-wait="Please wait..."
          class="button w-button"
          :style="
            'background:' +
            landingPage.themeColor +
            ';color:' +
            landingPage.negativeColor
          "
        />
      </div>
    </form>
    <div v-else class="form-box">
      <img
        v-if="landingPage.coverImage"
        :src="landingPage.coverImage.imageURL"
        loading="lazy"
        sizes="(max-width: 767px) 90vw, 600px"
        :alt="landingPage.siteUrl"
      />
      <div style="padding: 60px 40px">
        <h2 class="sec-head">{{landingPage.ThankYouMessage}}</h2>
        <div v-if="landingPage.eventDate">Add the event to calendar</div>
        <add-to-calendar
          v-if="landingPage.eventDate"
          :title="landingPage.title"
          location="https://jewishhome.netlify.app/"
          :start="new Date(landingPage.eventDate)"
          :end="
            new Date(
              new Date(landingPage.eventDate).setHours(
                new Date(landingPage.eventDate).getHours() + 1
              )
            )
          "
          details="Join the online event"
          inline-template
        >
          <div>
            <google-calendar
              id="google-calendar"
              class="button w-button addtocalendar"
            >
              Add to Google calendar
            </google-calendar>

            <microsoft-calendar
              id="microsoft-calendar"
              class="button w-button addtocalendar"
            >
              Add to Microsoft Live Calendar
            </microsoft-calendar>

            <office365-calendar
              id="office365-calendar"
              class="button w-button addtocalendar"
            >
              Add to outlook calendar (Office 365)
            </office365-calendar>
          </div>
        </add-to-calendar>
        <br>
        <a
          v-if="!this.landingPage.blockSite"
          @click="closeForm()"
          class="button w-button"
          :style="
            'background:' +
            landingPage.themeColor +
            ';color:' +
            landingPage.negativeColor
          "
          >Close</a
        >
         <a
          v-else-if="landingPage.resolutionURL"
          :href="landingPage.resolutionURL"
          class="button w-button"
          :style="
            'background:' +
            landingPage.themeColor +
            ';color:' +
            landingPage.negativeColor
          "
          >Continue To Site</a
        >
      </div>
    </div>

    <div class="w-form-fail">
      <div>Oops! Something went wrong while submitting the form.</div>
    </div>
  </div>
</template>

<style>
.addtocalendar {
  color: grey;
  border: 1px solid grey;
  margin-top: 15px;
}
.hero-image-popup {
  height: 100px;
  object-fit: scale-down;
  position: absolute;
  margin: 10px auto;
  left: 0;
  right: 0;
}

.cover-image-popup {
  height: 120px;
  object-fit: cover;
  width: 100%;
}
</style>


<script>

export default {
  name: "",
  props: { landingPage: Object, db: Object, registrationFields:Array},
  data() {
    return {
      fields: [],
      form: {},
      status: false,
    };
  },
  async mounted() {
  
let form = {}
    for (let field of this.registrationFields) {
      if (field.type != 100) {
        this.fields.push(field);
        form[field.slug] = "";
      }
    }
    this.$set(form, "form");
  },
  methods: {
    closeForm() {
      this.$emit("close", true);
      
    },
    async submitForm() {
      try {
        let {data} = await this.db.collection("registrations").post(this.form);
        this.$cookies.set("social-chat", data.id);
        this.status = true;
        this.$cookies.set(this.landingPage._id, "true");
        this.$emit("register",this.form)
        // if (!this.landingPage.blockSite) this.$emit("close", true);
      } catch (err) {
        this.status = "error";
        throw err;
      }
    },
  },
  computed: {
    startDate() {
      return new Date();
    },
    endDate() {
      return new Date(new Date().setDate(new Date().getDate() + 1));
    },
  },
};
</script>
